import React, { Suspense } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Navigation from './components/shared/Navigation';
import ScrollToTop from './components/shared/ScrollToTop';
import ErrorBoundary from './components/shared/ErrorBoundary';
import SkipToContent from './components/shared/SkipToContent';
import ProtectedRoute from './components/admin/ProtectedRoute';
import routes from './routes';

function App() {
  return (
    <ErrorBoundary>
      <Router>
        <SkipToContent />
        <ScrollToTop />
        <div className="App">
          <Navigation />
          <main id="main-content">
            <Suspense fallback={
              <div className="loading-container" style={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                minHeight: '50vh'
              }}>
                <div className="loading-spinner" role="status" aria-live="polite">
                  <span className="sr-only">Loading...</span>
                </div>
              </div>
            }>
              <Routes>
                {routes.map((route) => (
                  <Route
                    key={route.path}
                    path={route.path}
                    element={
                      route.protected ? (
                        <ProtectedRoute>
                          <route.element />
                        </ProtectedRoute>
                      ) : (
                        <route.element />
                      )
                    }
                  />
                ))}
              </Routes>
            </Suspense>
          </main>
        </div>
      </Router>
    </ErrorBoundary>
  );
}

export default App;
